import React from 'react';
import logo from '../images/chat2order_minilogo_rsz.png'

const ChatIcon = () => {
  return (
<img src={logo}  alt="logo" />
  )
}

export default ChatIcon;